<template>
    <div v-anchor>
        <div class="paperHeader">
            <Navigation :route="navigationRoute"></Navigation>
            <div class="paperHeaderTop mt-20">
                <div class="paperHeaderTop-title">
                    {{info.name}}
                </div>
                
            </div>
        </div>
        <div class="paper-con">
            <div class="paper-content">
                <div class="question-sections" v-for="(sec, secIndex) in paper.sections" :key="'s' + secIndex">
                    <div class="paperSecTitle" v-if="quesList[quesIndex].type==sec.trealType">
                        {{ secIndex + 1 | toChinesNum }}、{{ quesMap[sec.trealType] }}
                    </div>
                    <div v-for="(question, questionIndex) in sec.questions" :key="'q' + questionIndex"
                        class="page-question" :id="question.type + '_' + questionIndex" >
                        <div class="question-item" :id="'IdDiv'+question.id" v-if="quesList[quesIndex].id==question.id">
                            <!-- <div class="question-title-item">
                                <div class="question-title"
                                    v-html="'【' + quesMap[question.type] + '】' + (questionIndex + 1) + '、' + deleteP(question.content)">
                                </div>
                            </div> -->

                            <div class="question-select mt-10"
                                v-if="question.type == 'SINGLECHOICE' || question.type == 'MULTIPLECHOICE' || question.type == 'JUDGMENT'">
                                <choice :info="question" :no="questionIndex" @choose="change" :readOnly="readOnly" :lastNext="lastNext" :submit="true" @submit="changeSubmit(question.id,answers['Q-' +question.id])"
                                    :check="checks[question.id]" v-model="answers['Q-' +question.id]" @lastNext="handleLastNext" isOne></choice>
                            </div>


                            <!-- 套题开始 -->
                            <div v-else-if="question.type == 'TT'" class=" mt-10">
                                <tt :info="question" :readOnly="readOnly" :lastNext="lastNext"  @lastNext="handleLastNext" :submit="true" isOne :no="questionIndex"
                                    @input="change" @submit="changeSubmit(question.id,answers['Q-' +question.id])">
                                    </tt>
                            </div>
                            <!-- 套题结束 -->

                            <div v-else>
                                <div class=" mt-10" v-if="question.type == 'BLANKFILL'">
                                    <blank class="mt-10" :info="question" :no="questionIndex" :readOnly="readOnly" :lastNext="lastNext" @lastNext="handleLastNext" :submit="true" @submit="changeSubmit(question.id,answers['Q-' +question.id])"
                                        :check="checks[question.id]" v-model="answers['Q-' +question.id]" isOne ></blank>
                                </div>
                                <div class="question-textarea mt-10" v-else>
                                    <essay :info="question" :no="questionIndex" :readOnly="readOnly" :lastNext="lastNext" @lastNext="handleLastNext" :submit="true" @submit="changeSubmit(question.id,answers['Q-' +question.id])"
                                        :check="checks[question.id]" v-model="answers['Q-' +question.id]" isOne></essay>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

               
            </div>
            <!-- 答题卡 -->
            <div class="answerBox ml-15">
                <div class="answerBox-date flex-btw">
                    <div class="flex-ctr">
                        <div class="btn-item-text ml-10">{{info.jd}}/{{info.all}}</div>
                    </div>
                </div>
                <cardList :list="paper.sections" @submit="submit(1)" :answers="answers" v-if="paper.sections" :lastNext="lastNext" @toNext="handleToNext">
                </cardList>
            </div>
        </div>

    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { saveData, testStart, testSaveData } from "@/api/myTest.js";
import { mapState, mapMutations } from "vuex";
import choice from "@/components/question/choice.vue";
import blank from "@/components/question/blank.vue";
import essay from "@/components/question/essay.vue";
import cardList from "@/components/question/cardList.vue";
import examData from "./exam.json"
import tt from "@/components/question/tt.vue";
import { quesMap } from "@/utils/enum"
export default {
    name: "",
    components: {
        Navigation,
        choice,
        blank,
        essay,
        cardList,
    tt,
},
    data() {
        return {
            navigationRoute: [
                { name: '我的测试' },
                { name: '个人自测' },
            ],
            readOnly: false,
            lastNext: true,
            quesMap,
            title: '',
            shortestDeliverLeftTime: 0,
            answers: {
            },
            paper: {

            },
            cardList: [],
            id: '',
            url: '',
            timer: null,
            submitTimer: null,
            timerCountDown: null,
            paperInfo: {},
            imgList: [],
            checks: {},
            quesList:[],
            quesIndex:0,
            info:{

            },
            sortPaper:['SINGLECHOICE','MULTIPLECHOICE','JUDGMENT','BLANKFILL','ESSAY','MCJST','LST','JDT','TT']
        };
      
    },
    created() {
        this.id = this.$route.query.id
        this.info=this.$route.query
        this.start()
    },
    computed: {
    },
    methods: {
        start() {
            const that = this
            testStart({ id: this.id }).then(res => {
                let paperInfo={
                    ...this.info,
                    sections:[],
                    answers:{}
                   
                }
                paperInfo.sections=this.sortPaper.map(e=>{
                    return{trealType:e,questions:res.filter(q=>{
                        if(q.studentAnswer){
                            if(q.type=='BLANKFILL'){
                                var reg = new RegExp('\\[BlankArea\\d]', 'g');
                                v.content = v.content.replace(reg, '____');
                                // 
                                    // if (q.studentAnswer) {
                                    //     paperInfo.answers['Q-' + q.id] = q.studentAnswer.split(',')
                                    // } else {
                                    //     paperInfo.answers['Q-' + q.id] = []
                                    //     q.blanks.map(b => {
                                    //         paperInfo.answers['Q-' + q.id].push('')
                                    //     })
                                    // }
                            }
                                paperInfo.answers['Q-'+q.id]=q.studentAnswer
                        }
                        if(q.data){
                            q.options=q.data.options
                            q.blanks=q.data.blanks
                        }
                       return q.type==e
                    })}
                })
                    this.info.jd=res.filter(e=>e.studentAnswer).length
                    this.info.all=res.length
                    this.answers = paperInfo.answers
                    paperInfo.sections=paperInfo.sections.filter(e=>e.questions.length)
                    this.title = this.paper.name
                    paperInfo.sections.forEach(item => {
                        item.questions.forEach((q,i) =>{
                            q.no = i + 1 
                        })
                        this.quesList = this.quesList.concat(item.questions.map(e=>{return{...e,pId:item.id,...e.data}}))
                    })
                    this.paper = paperInfo

                })
            
        },
       
        
        deleteP(html) {
            return html.replace(/<p.*?>/ig, "")
        },
        // change(data) {
        //     this.sections.map((v) => {
        //         v.questions.map((v_) => {
        //             if (v_.id == data.id) {
        //                 v_.myAnswer = data.value;
        //             }
        //         });
        //     });
        //     this.sections = JSON.parse(JSON.stringify(this.sections));
        // },
        change (data) {
            this.answer = data
        },
        // 上下题
        handleLastNext (row) {
        if (row == 'last') {
            if (this.quesIndex == 0) {
            this.$message({
                showClose: true,
                message: '已经是第一题了',
                type: 'error'
            });
            return
            }
            this.quesIndex--
        }
        if (row == 'next') {
            this.quesIndex++
            if (this.quesIndex >= this.quesList.length) {
            this.quesIndex = this.quesList.length - 1
            this.$message({
                showClose: true,
                message: '已经是最后一题了',
                type: 'error'
            });
            return
            }
        }
        this.changeQuestion(this.quesList[this.quesIndex])
        },
        // 快速跳题
        changeQuestion (item, sort) {
        if (sort) {
            this.quesIndex = sort - 1
        }
        this.question = item
        this.readOnly = false

        },
        handleToNext(id){
           const index= this.quesList.findIndex(e=>e.id==id)
           if(this.quesIndex ==index){
            return
           }
           this.quesIndex =index
            this.changeQuestion(this.quesList[this.quesIndex])
        },
    changeSubmit (id,answer) {
      const params = {
        id,
        dbId: this.info.id,
        answer
      };
      testSaveData(params).then((res) => {
        this.readOnly = true
        this.$forceUpdate();
        this.info.jd+=1
        // this.question.isCorrect = res.isCorrect
        // if (res.isCorrect == 1) this.paperData.yesNum++;
        // if (res.isCorrect == 0) this.paperData.noNum++;
        // if (res.isCorrect == 0 || res.isCorrect == 1) this.paperData.doNum++;
      });
    }
    },
};
</script>
<style lang="scss" scoped>
.paperHeader {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 5px;

    .paperHeaderTop {
        .paperHeaderTop-title {
            text-align: center;
            font-weight: 500;
            font-size: 22px;
            color: #1A1A1A;
        }

        .paperHeaderTop-c {
            width: 80%;
            margin: auto;
            font-weight: 400;
            font-size: 14px;

            .paperHeaderTop-c-label {
                color: #767676;
            }
        }
    }

}

.paper-con {
    margin-top: 20px;

    .paper-content {
        background: #FFFFFF;
        padding: 20px;
        border-radius: 5px;
        flex:1;
    }

    display: flex;
}

.paperSecTitle {
    font-weight: 500;
    font-size: 14px;
    color: #1A1A1A;
}

.answerBox {
    width: 340px;
    min-width: 340px;
    box-sizing: border-box;
    border-radius: 5px;
    // min-height: 20%;
    // max-height: 80%;
    // height: 100%;
    background: #fff;
    // overflow-y: auto;
    overflow-y: hidden;
    position: sticky;
    top: 10px;
    height: 100%;
    .answerBox-date {
        font-weight: 400;
        font-size: 24px;
        color: #1A1A1A;
        padding: 15px;
        background: #FFF4E8;
    }
}
</style>